import { Deeplinks } from '@awesome-cordova-plugins/deeplinks/ngx';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { File } from '@awesome-cordova-plugins/file/ngx';
import { HttpClient } from '@angular/common/http';
import { Camera } from '@awesome-cordova-plugins/camera/ngx';
import { Network } from '@awesome-cordova-plugins/network/ngx';
import { IonicStorageModule } from '@ionic/storage-angular';
import { RouteReuseStrategy } from '@angular/router';
import { StatusBar } from '@awesome-cordova-plugins/status-bar/ngx';
import { BrowserModule } from '@angular/platform-browser';
import { WebView } from '@awesome-cordova-plugins/ionic-webview/ngx';
import { MediaCapture } from '@awesome-cordova-plugins/media-capture/ngx';
import { SplashScreen } from '@awesome-cordova-plugins/splash-screen/ngx';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { BasePage } from './pages/base.page';
// import { HamburgerMenuComponent } from './components/hamburger-menu/hamburger-menu.component';

import { AppComponent } from './app.component';
import { CommonModule } from '@angular/common';
import { AppRoutingModule } from './app-routing.module';
import { ServicesModule } from './services/services.module';
import { Geolocation } from '@awesome-cordova-plugins/geolocation/ngx';
import { SharedModule } from './pages/shared-module/shared.module';
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';
// import { CounterOfferModalComponent } from './components/counter-offer-modal/counter-offer-modal.component';
// import { LinkifyPipe } from './pipes/linkify/linkify.pipe';

import { LinkifyModule } from './pipes/linkify/linkify.module';
import { ChatDetailPageModule } from './pages/chat-detail/chat-detail.module';
import { GoogleMapsModule } from '@angular/google-maps';
import { NgxGpAutocompleteModule } from '@angular-magic/ngx-gp-autocomplete';
import { Loader } from '@googlemaps/js-api-loader';
import { OneSignal, oneSignalProviders } from 'src/cordova/onesignal';
// import { SocialSharing } from '@awesome-cordova-plugins/social-sharing/ngx';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, '../assets/i18n/', '.json');
}

@NgModule({
  declarations: [AppComponent, BasePage],
  imports: [
    SharedModule,
    BrowserModule,
    CommonModule,
    ServicesModule,
    // IonicModule.forRoot({
    //   mode: 'ios',
    //   backButtonText: '',
    //   backButtonIcon: '../assets/icons/left-arrow.svg',
    //   menuIcon: '../assets/icons/menu.svg'
    // }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    AppRoutingModule,
    // SwiperModule,
    IonicModule.forRoot({
      innerHTMLTemplatesEnabled: true,
    }),
    IonicStorageModule.forRoot(),
    ChatDetailPageModule,
    LinkifyModule,
    GoogleMapsModule,
    NgxGpAutocompleteModule,
    // LinkifyPipe
  ],
  providers: [
    oneSignalProviders,
    Camera,
    WebView,
    StatusBar,
    SplashScreen,
    MediaCapture,
    Network,
    File,
    Deeplinks,
    Geolocation,
    InAppBrowser,
    // SocialSharing,
    {
      provide: Loader,
      useValue: new Loader({
        apiKey: 'AIzaSyBYkjr0dEwdnn9oj-SyBMKehpO7-K2SEVU',
        libraries: ['places', 'maps'],
      }),
    },
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
